export default "__VITE_ASSET__BMt1nLnG__"